import LazyLoad from "vanilla-lazyload";
import inView from "in-view";
import lottie from "lottie-web";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import Flickity from "flickity";
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
const HTML = document.querySelector("html");
class App {
  constructor() {
    this.lazyload = new LazyLoad({
      unobserve_entered: true,
      elements_selector: ".js-lazy",
      threshold: window.innerHeight * 0.8,
      callback_enter: ($el) => {
        if ($el.classList.contains("js-lazy-error-placeholder")) {
          $el.lazyLoadPlaceholder = $el.src;
        } else if ($el.dataset.src == void 0) {
          const figure = $el.closest("figure");
          if (figure)
            figure.classList.add("img-is-loaded");
        }
      },
      callback_loaded: (el) => {
        const figure = el.closest("figure");
        if (figure)
          figure.classList.add("img-is-loaded");
      },
      callback_error: ($el) => {
        if ($el.lazyLoadPlaceholder) {
          $el.src = $el.lazyLoadPlaceholder;
        }
      }
    });
    const toggles = document.querySelectorAll(".toggle-menu");
    if (toggles) {
      toggles.forEach((toggle) => {
        toggle.addEventListener("click", (e) => {
          e.preventDefault();
          HTML.classList.toggle("open-menu");
        });
      });
    }
    const anchors = document.querySelectorAll('a[href*="#"]:not([href="#"])');
    if (anchors) {
      anchors.forEach((anchor) => {
        anchor.addEventListener("click", (e) => {
          e.preventDefault();
          const target = document.querySelector(anchor.getAttribute("href"));
          if (target) {
            gsap.to(window, {
              ease: "expo.out",
              duration: 0.8,
              scrollTo: {
                y: target,
                offsetY: document.querySelector(".main-header").scrollHeight + 30
              }
            });
          }
        });
      });
    }
    const mainHeader = document.querySelector(".main-header");
    const main = document.querySelector(".main");
    if (main) {
      const sections = main.querySelectorAll("section");
      const everShow = sections && !sections[0].classList.contains("bg-green-900") && !sections[0].classList.contains("s:min-h-screen");
      window.addEventListener("scroll", () => {
        if (window.scrollY > mainHeader.scrollHeight * 3 || everShow) {
          HTML.classList.add("scrolldown");
        } else {
          HTML.classList.remove("scrolldown");
        }
      });
    }
    this.bodymovin();
    this.parallax();
    this.marquee();
    this.hoverTabs();
    this.gifEffect();
    this.filter();
    this.sticky();
    this.carousel();
    this.inViewport();
  }
  gifEffect() {
    const elts = document.querySelectorAll(".gif-hover");
    if (elts) {
      elts.forEach((figure) => {
        const images = gsap.utils.toArray(".inner", figure);
        gsap.set(images, { autoAlpha: 0 });
        gsap.set(images[0], { autoAlpha: 1 });
        const tl = gsap.timeline({
          paused: true,
          repeat: -1
        });
        images.forEach((img, i) => {
          tl.to(images, {
            autoAlpha: 0,
            duration: 0
          });
          tl.to(images[i], {
            autoAlpha: 1,
            duration: 0
          });
          tl.to({}, {
            duration: 0.4
          });
        });
        figure.addEventListener("mouseenter", () => tl.play());
        figure.addEventListener("mouseleave", () => {
          tl.pause(0);
          gsap.set(images, { autoAlpha: 0 });
          gsap.set(images[0], { autoAlpha: 1 });
        });
      });
    }
  }
  carousel() {
    const elts = document.querySelectorAll(".carousel");
    if (elts) {
      elts.forEach((el) => {
        const nav = el.querySelectorAll(".carousel-nav a");
        let current = -1;
        const flkty = new Flickity(el, {
          cellAlign: "center",
          wrapAround: true,
          cellSelector: ".item",
          prevNextButtons: false,
          pageDots: false,
          autoPlay: 5e3,
          pauseAutoPlayOnHover: true,
          on: {
            select: (index) => {
              if (nav && nav[current])
                nav[current].classList.remove("active");
              if (nav && nav[index])
                nav[index].classList.add("active");
              current = index;
            }
          }
        });
        if (nav) {
          nav.forEach((link, i) => {
            link.addEventListener("click", (e) => {
              e.preventDefault();
              flkty.select(i);
            });
          });
        }
      });
    }
  }
  hoverTabs() {
    const elts = document.querySelectorAll(".hover-tabs");
    if (elts) {
      elts.forEach((el) => {
        const imgs = el.querySelectorAll(".imgs .item figure");
        const marquees = el.querySelectorAll(".imgs .marquee");
        const nav = el.querySelectorAll(".nav a");
        let current = -1;
        imgs.forEach((item, i) => {
          gsap.set(item, {
            clipPath: "polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)"
          });
          gsap.set(marquees[i], {
            y: "2rem",
            autoAlpha: 0
          });
        });
        if (nav) {
          let goto = function(i) {
            if (onAnimate)
              return;
            if (nav[i].classList.contains("active"))
              return;
            let delay = 0;
            onAnimate = true;
            if (current >= 0) {
              imgs.forEach((prevItem, j) => {
                if (j != i) {
                  gsap.to(prevItem, {
                    clipPath: "polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)",
                    duration: 0.5,
                    ease: "circ.inOut"
                  });
                  gsap.to(marquees[j], {
                    y: "-2rem",
                    autoAlpha: 0,
                    duration: 0.2,
                    ease: "expo.in",
                    delay: 0.1
                  });
                }
              });
              delay = 0.3;
              nav[current].classList.remove("active");
            }
            const nextItem = imgs[i];
            gsap.fromTo(nextItem, {
              clipPath: "polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)"
            }, {
              clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
              duration: 0.5,
              ease: "circ.inOut"
            });
            gsap.fromTo(nextItem.querySelector(".inner"), {
              scale: 1.2
            }, {
              scale: 1,
              duration: 0.5,
              ease: "circ.inOut",
              onComplete: () => {
                onAnimate = false;
              }
            });
            gsap.fromTo(marquees[i], {
              y: "1.5rem",
              autoAlpha: 0
            }, {
              y: "0rem",
              autoAlpha: 1,
              delay: 0.1 + delay,
              duration: 0.2,
              ease: "expo.out"
            });
            nav[i].classList.add("active");
            current = i;
          }, autoplay = function() {
            timer = setInterval(() => {
              const next = current < imgs.length - 1 ? current + 1 : 0;
              goto(next);
            }, 5e3);
          };
          let onAnimate = false;
          let timer = 0;
          nav.forEach((pager, i) => {
            pager.addEventListener("click", (e) => {
              e.preventDefault();
              goto(i);
            });
            pager.addEventListener("mouseenter", () => {
              clearInterval(timer);
            });
            pager.addEventListener("mouseleave", () => {
              autoplay();
            });
          });
          el.addEventListener("inview", () => {
            if (current < 0) {
              goto(0);
              autoplay();
            }
          });
        }
      });
    }
  }
  filter() {
    const elts = document.querySelectorAll(".filter");
    if (elts) {
      elts.forEach((el) => {
        const parent = el.closest("section");
        const triggers = el.querySelectorAll("[data-filter]");
        const items = parent.querySelectorAll(el.dataset.targets);
        const currentVal = parent.querySelector(".current-val");
        if (triggers) {
          const select = parent.querySelector("select[data-targets]");
          if (select) {
            select.addEventListener("change", () => {
              const t = parent.querySelector(`[data-filter='${select.value}']`);
              if (t)
                t.dispatchEvent(new Event("click"));
            });
          }
          triggers.forEach((trigger) => {
            trigger.addEventListener("click", (e) => {
              e.preventDefault();
              if (trigger.classList.contains("active"))
                return;
              triggers.forEach((t) => t.classList.remove("active"));
              trigger.classList.add("active");
              currentVal.innerHTML = trigger.innerText;
              items.forEach((item) => {
                if (item.classList.contains(trigger.dataset.filter)) {
                  gsap.to(item, {
                    height: item.scrollHeight,
                    ease: "circ.inOut",
                    duration: 0.3,
                    onComplete: () => {
                      gsap.set(item, { clearProps: "height" });
                    }
                  });
                } else {
                  gsap.to(item, {
                    ease: "circ.inOut",
                    duration: 0.3,
                    height: "0"
                  });
                }
              });
            });
          });
        }
      });
    }
  }
  sticky() {
    const elts = document.querySelectorAll("[data-sticky]");
    if (elts) {
      elts.forEach((el) => {
        const container = el.dataset.stickyContainer != void 0 ? document.querySelector(el.dataset.stickyContainer) : el.parentElement;
        const offsetBottom = el.dataset.stickyOffsetBottom != void 0 ? el.dataset.stickyOffsetBottom : 0;
        const stopOffset = el.dataset.stickyStopOffset != void 0 ? el.dataset.stickyStopOffset : 0;
        const mode = el.dataset.stickyMode != void 0 ? el.dataset.stickyMode : "absolute";
        let placeholder = null;
        placeholder = document.createElement("div");
        placeholder.style.height = `${el.offsetHeight}px`;
        placeholder.style.display = "block";
        el.parentNode.insertBefore(placeholder, el);
        const rect = placeholder.getBoundingClientRect();
        el.style.top = `${rect.top - placeholder.parentElement.getBoundingClientRect().top}px`;
        window.addEventListener("scroll", () => update());
        window.addEventListener("resize", () => update());
        setTimeout(() => {
          window.dispatchEvent(new Event("resize"));
        }, 100);
        function update() {
          const rect2 = placeholder.getBoundingClientRect();
          const containerRect = container.getBoundingClientRect();
          const viewportHeight = window.innerHeight;
          const triggerPoint = viewportHeight - offsetBottom;
          el.classList.add("is-ready");
          const containerBottomLimit = containerRect.bottom - stopOffset * window.innerHeight;
          if (rect2.bottom <= triggerPoint) {
            if (containerBottomLimit <= viewportHeight - offsetBottom) {
              if (mode === "absolute") {
                el.classList.remove("sticky-active");
                el.classList.add("sticky-absolute");
                el.style.bottom = "0";
              } else if (mode === "fade") {
                el.classList.add("sticky-fade");
              }
            } else {
              el.classList.add("sticky-active");
              el.classList.remove("sticky-absolute", "sticky-fade");
              el.style.bottom = `${offsetBottom}px`;
              el.style.top = `auto`;
            }
          } else {
            el.classList.remove("sticky-active");
            el.classList.remove("sticky-absolute");
            el.style.bottom = `auto`;
            el.style.top = `${rect2.top - placeholder.parentElement.getBoundingClientRect().top}px`;
          }
        }
      });
    }
  }
  pinTabs() {
    const elts = document.querySelectorAll(".sticky-tabs");
    if (elts) {
      elts.forEach((el) => {
        const imgs = el.querySelectorAll(".imgs .item");
        const marquees = el.querySelectorAll(".imgs .marquee");
        const nav = el.querySelectorAll(".nav a");
        imgs.forEach((item, i) => {
          if (i !== 0) {
            gsap.set(item, {
              y: "80%",
              scale: 1.5,
              autoAlpha: 0
            });
            gsap.set(marquees[i], {
              y: "2rem",
              autoAlpha: 0
            });
          }
        });
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: el,
            start: "top top",
            end: `+=${window.innerHeight * imgs.length}`,
            scrub: true,
            pin: true
          }
        });
        imgs.forEach((item, i) => {
          if (i === imgs.length - 1)
            return;
          const current = item;
          const nextItem = imgs[i + 1];
          tl.to(item, {
            autoAlpha: 0,
            duration: 0.2,
            ease: "none"
          }, i + 0.2);
          tl.to(item, {
            y: "-80%",
            scale: 0.5,
            duration: 1,
            ease: "none"
          }, i);
          tl.to(marquees[i], {
            y: "-3rem",
            autoAlpha: 0,
            duration: 0.1,
            ease: "none"
          }, i);
          tl.to(nextItem, {
            autoAlpha: 1,
            duration: 0.3,
            ease: "none"
          }, i);
          tl.to(nextItem, {
            y: "0%",
            duration: 1,
            scale: 1,
            ease: "none"
          }, i);
          tl.to(marquees[i + 1], {
            y: "0rem",
            autoAlpha: 1,
            duration: 0.2,
            ease: "none",
            onStart: (self) => {
              nav[i].classList.remove("active");
              nav[i + 1].classList.add("active");
            },
            onReverseComplete: () => {
              nav[i].classList.add("active");
              nav[i + 1].classList.remove("active");
            }
          }, i + 0.5);
        });
        if (nav) {
          const trigger = tl.scrollTrigger;
          nav.forEach((pager, i) => {
            pager.addEventListener("click", (e) => {
              e.preventDefault();
              const progress = i / (nav.length - 1);
              const scrollPosition = trigger.start + progress * (trigger.end - trigger.start);
              gsap.to(window, {
                scrollTo: scrollPosition,
                duration: 0.3,
                expo: "expo.out"
              });
            });
          });
        }
      });
    }
  }
  bodymovin() {
    const tags = document.querySelectorAll("[data-bodymovin]:not(.ready)");
    if (tags) {
      tags.forEach((tag) => {
        tag.classList.add("ready");
        if (!tag.classList.contains("loaded")) {
          const anim = tag.dataset.bodymovin;
          fetch(anim).then((response) => {
            if (response.status == 200) {
              const l = lottie.loadAnimation({
                container: tag,
                renderer: "svg",
                loop: true,
                autoplay: !(tag.dataset.bodymovinAutoplay && tag.dataset.bodymovinAutoplay != "0"),
                path: anim
              });
              l.addEventListener("DOMLoaded", () => {
                tag.classList.add("loaded");
              });
              tag.lottie = l;
              if (tag.dataset.bodymovinAutoplay && tag.dataset.bodymovinAutoplay != "") {
                setTimeout(() => {
                  l.play();
                  tag.classList.add("loaded");
                }, Number.parseFloat(tag.dataset.bodymovinAutoplay) * 1e3);
              } else {
              }
            }
          });
        } else if (tag.lottie) {
          tag.lottie.play();
        }
        tag.addEventListener("outview", () => {
          if (tag.lottie) {
          }
        });
      });
    }
  }
  parallax() {
    const elts = document.querySelectorAll("[data-speed]");
    if (elts) {
      elts.forEach((el) => {
        const speed = Number.parseFloat(el.dataset.speed) || 1;
        const lag = Number.parseFloat(el.dataset.lag) || 0;
        const y = 0;
        let targetY = 0;
        ScrollTrigger.create({
          trigger: el,
          start: "top bottom",
          end: "bottom top",
          scrub: true,
          onUpdate: (self) => {
            targetY = (1 - speed) * self.progress * 50;
            if (lag) {
              gsap.to(el, {
                y: targetY,
                duration: lag,
                ease: "power3.out",
                overwrite: true
              });
            } else {
              gsap.set(el, { y: targetY });
            }
          }
        });
      });
    }
  }
  marquee() {
    const elts = document.querySelectorAll(".marquee .line");
    if (elts) {
      elts.forEach((track) => {
        track.innerHTML += track.innerHTML;
        this.lazyload.update();
        let direction = 1;
        const speed = 40;
        let x = 0;
        let wrapWidth;
        let lastScrollY = window.scrollY;
        function computeWrapWidth() {
          wrapWidth = track.scrollWidth / 2;
        }
        window.addEventListener("load", computeWrapWidth);
        window.addEventListener("resize", computeWrapWidth);
        window.addEventListener("scroll", () => {
          const currentScrollY = window.scrollY;
          if (currentScrollY > lastScrollY) {
            direction = 1;
          } else if (currentScrollY < lastScrollY) {
            direction = -1;
          }
          lastScrollY = currentScrollY;
        }, { passive: true });
        let lastTime = performance.now();
        gsap.ticker.add(() => {
          const now = performance.now();
          const dt = (now - lastTime) / 1e3;
          lastTime = now;
          if (!wrapWidth)
            return;
          x += direction * speed * dt;
          if (x <= -wrapWidth) {
            x += wrapWidth;
          } else if (x >= 0) {
            x -= wrapWidth;
          }
          gsap.set(track, { x });
        });
      });
    }
  }
  inViewport() {
    inView.offset({
      bottom: window.innerHeight * 0.1
    });
    inView(".js-reveal:not(.is-visible)").on("enter", function(elt) {
      elt.dispatchEvent(new Event("inview"));
      elt.classList.add("is-visible");
      elt.classList.remove("not-visible");
      const video = elt.querySelector("video");
      if (elt.tagName == "VIDEO" && elt.dataset.autoplay == "true" || video && video.dataset.autoplay == "true") {
        const v = video || elt;
        const playPromise = v.play();
        if (playPromise !== null) {
          playPromise.catch(() => {
            v.play();
          });
        }
      }
    }).on("exit", function(elt) {
      const video = elt.querySelector("video");
      if (elt.tagName == "VIDEO" && elt.dataset.autoplay != "" || video && video.dataset.autoplay != "") {
        const v = video || elt;
        v.pause();
      }
      elt.dispatchEvent(new Event("outview"));
      elt.classList.add("not-visible");
    });
  }
}
window.addEventListener("DOMContentLoaded", () => {
  new App();
});


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
